import { message } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { ERROR, SUCCESS } from '../constants/notifications'

// TODO cleanup notifications after some time

class Notifications extends React.Component<any, any> {
  static propTypes = {
    notifications: PropTypes.array.isRequired,
    defaultDuration: PropTypes.number,
  }

  state = {
    defaultDuration: 5,
  }

  componentDidUpdate() {
    const { notifications, defaultDuration } = this.props
    notifications.forEach((notification) => {
      switch (notification.kind) {
        case ERROR:
          message.error(notification.message, notification.duration || defaultDuration)
          break
        case SUCCESS:
          message.success(notification.message, notification.duration || defaultDuration)
          break
        default:
          break
      }
    })
  }

  render() {
    return null
  }
}

const mapStateToProps = (state, props) => ({
  ...props,
  notifications: state.notifications.show,
})

export default connect(mapStateToProps)(Notifications)



// WEBPACK FOOTER //
// ./src/components/Notifications.tsx